// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ClaimErrorField = t.struct({
    itemNumber: t.maybe(t.String),
    itemType: t.maybe(t.String),
    key: t.maybe(t.String),
    value: t.maybe(t.String)
}, {
    name: 'ClaimErrorField',
    strict: true
});

export const getDefaultState = () => new ClaimErrorField({
    itemNumber: '',
    itemType: '',
    key: '',
    value: ''
});

export default ClaimErrorField;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-error-field.js